import { useRouter } from 'next/router'
import { useQRCode } from 'next-qrcode'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useTranslation } from 'next-i18next'
import { AugmentedRealityPopup } from './AugmentedRealityPopup'
import { DialogContent, DialogOverlay } from '@reach/dialog'
import { Icon } from '~/elements/Icons/Icon'

type Props = {
  sku: string
  uuid: string
  open: boolean
  close: () => void
}

export const AugmentedRealityBlock = ({ sku, uuid, open, close }: Props) => {
  const { Canvas } = useQRCode()
  const { t } = useTranslation()

  const router = useRouter()

  const [showPopup, setShowPopup] = useState(false)
  const closePopup = () => setShowPopup(false)

  useEffect(() => setShowPopup(router.query?.ar === 'open'), [router?.isReady])

  return (
    <>
      {uuid && (
        <DialogOverlay
          style={{
            width: '100vw',
            height: '100vh',
            top: 0,
            left: 0,
            zIndex: 9999,
            padding: 0,
            margin: 0,
          }}
          isOpen={open}
          onDismiss={close}
        >
          <DialogContent
            style={{
              position: 'relative',
              width: '295px',
            }}
          >
            <>
              <button
                className="absolute top-4 right-4 z-50 grid h-10 w-10 place-items-center rounded-full bg-grey-light"
                onClick={close}
              >
                <Icon name="cross" />
              </button>
              <div className="w-full text-left">
                <h2 className="w-full text-[25px] font-medium	">{t('Show in AR')}</h2>
                <h4 className="mt-2 w-full text-[15px] font-medium">
                  {t(
                    'Scan the QR code with your mobile device to display the product in your room.',
                  )}
                </h4>
              </div>
              <div className="mt-4 flex w-full justify-center">
                <Canvas
                  text={`https://${
                    process.env.NEXT_PUBLIC_VERCEL_ENV == 'production'
                      ? process.env.NEXT_PUBLIC_DOMAIN_NAME
                      : process.env.NEXT_PUBLIC_VERCEL_URL
                  }${router.asPath.split('#')[0]}${
                    !router.asPath.includes('ar=')
                      ? router.asPath.includes('?')
                        ? '&ar=open'
                        : '?ar=open'
                      : ''
                  }`}
                  options={{
                    level: 'H',
                    width: 256,
                    color: {
                      dark: '#000',
                      light: '#fff',
                    },
                  }}
                />
              </div>
            </>
          </DialogContent>
        </DialogOverlay>
      )}
      {uuid && <AugmentedRealityPopup sku={sku} uuid={uuid} open={showPopup} close={closePopup} />}
    </>
  )
}

export default AugmentedRealityBlock
